import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import type { MenuProps } from "antd";
import { Menu } from "antd";

import {
  ContainerOutlined,
  MenuOutlined,
  ToolOutlined,
  RocketOutlined,
} from "@ant-design/icons";

import { googleLogout } from "@react-oauth/google";

import { useAppDispatch } from "../../store/hooks";
import { removeUserInfo } from "../../features/user/userSlice";
import { removeInstance } from "../../features/instance/instanceSlice";
import { removeSelectionInfo } from "../../features/selection/selectionSlice";
import { clearAllSessions } from "../../utility/common/session-store";
import { updateMenuKey } from "../../features/settings/settingsSlice";
import { LangComp } from "../LangComp";
import { useAuth } from "../../utility/AuthContext";

type MenuItem = Required<MenuProps>["items"][number];

export const ProviderMainMenu = () => {
  const { t } = useTranslation();
  const { isLoggedIn, setShowLoginModal, logout } = useAuth();
  const [menuType, setMenuType] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuType(!menuType);
  };

  const navigateLink = (menuKey: number, param: string) => {
    dispatch(updateMenuKey(menuKey));
    toggleMenu();
    navigate(param);
  };

  const providerMainMenuItems: MenuItem[] = [
    {
      key: "1",
      icon: <ToolOutlined />,
      label: (
        <div onClick={() => navigateLink(1, "/installation")}>
          {t("Installation")}
        </div>
      ),
    },
    {
      key: "2",
      icon: <ContainerOutlined />,
      label: (
        <div onClick={() => navigateLink(2, "/profits")}>{t("Profits")}</div>
      ),
    },
    {
      key: "3",
      icon: <RocketOutlined />,
      label: (
        <div onClick={() => navigateLink(3, "/machineStatus")}>
          {t("Machine Status")}
        </div>
      ),
    },
  ];

  const handleLogInLogOut = () => {
    if (isLoggedIn) {
      googleLogout();
      document.cookie =
        "g_state=; path=/; domain=.google.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      dispatch(removeUserInfo());
      dispatch(removeInstance());
      dispatch(removeSelectionInfo());
      clearAllSessions();
      logout();
      if (location.pathname === "/") {
        window.location.reload();
      } else {
        navigate("/", { replace: true });
      }
    }
  };

  return (
    <div className="main-menu">
      <aside>
        <div
          className={
            menuType ? "main-menu-wrapper" : "main-menu-wrapper show-mobile"
          }
        >
          <Menu
            mode="inline"
            inlineIndent={8}
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["0"]}
            items={providerMainMenuItems}
          />
          <div className="bottom-menu">
            <LangComp />
            <div
              data-no-auth
              style={{ cursor: "pointer" }}
              onClick={() => handleLogInLogOut()}
            >
              {isLoggedIn ? t("Log Out") : t("Log In")}
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};
